import _ from 'underscore'
// TODO: need to use nulls instead of empty strings in customer form.
// Once the customer form is using nulls, we can eliminate this `returnNullForEmptyString` parameter.
export const scrubText = (val, returnNullForEmptyString = false) => {
  const value = val && val.replace(/ +/g, ' ')

  if (returnNullForEmptyString && _.isEmpty(value)) return null

  return value
}

export const scrubNumber = (val, returnNullForZero = false) => {
  const value = val && val.replace(/\s+/g, '')

  if (isNaN(value)) { return null }

  const numericValue = Number(value)

  if (returnNullForZero && numericValue === 0) { return null }

  return numericValue
}

export const scrubPhone = (val) => val && val.trim().replace(/\D/g, '')
